import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import Calendar from '../../ui/Calendar'

@inject("store")
@observer
export default class DateChooser extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    onChange: PropTypes.func
  }

  handleDateChosen = (value) => {
    const { store } = this.props
    store.progress({ activeDate: value })
  }

  render() {
    const { store } = this.props

    return (
      <Calendar
        name="calendar"
        label="Choose a date"
        dateFormat={store.franchise.attributes.dateFormat}
        onChange={this.handleDateChosen}
        minDate={store.calendarStartDate}
      />
    )
  }
}

const styles = {
  wrapper: {
    display: "inline-block"
  }
}
